import theme from '../styles/theme'

export default theme
